import { getWindow } from './global'

export type FlagName = 'firehoseDemoMode' | 'hideOperatorNames'

export const FlagNames: FlagName[] = ['firehoseDemoMode', 'hideOperatorNames']

export function getFlag(name: FlagName) {
  return getWindow()!.localStorage.getItem(name) === 'true'
}

export function setFlag(name: FlagName, val: boolean) {
  getWindow()!.localStorage.setItem(name, '' + val)
}
